import React from 'react';
import { Card } from '../../design-system';
import { FaRegTrashAlt, FaEdit } from 'react-icons/fa';
import { Table, TableCardHeader } from '../../components/Table';
import ButtonCellColumn from '../../components/ButtonCellColumn';
import { prettyPhone } from '../../helpers/utils';

interface ContactPhoneProps {
  phones: any[];
  canEdit: boolean;
  toggleModal: () => void;
  setModalType: (value: any) => void;
  toggleEditModal: () => void;
  handleDeleteDetailsHandler: (value: any) => void;
}

const ContactPhone = ({
  phones,
  canEdit,
  toggleModal,
  setModalType,
  toggleEditModal,
  handleDeleteDetailsHandler,
}: ContactPhoneProps) => {
  const CONTACT_PHONE_COLUMNS = [
    {
      Header: 'Phone #',
      accessor: 'value',
      Cell: ({
        row: {
          original: { value },
        },
      }) => prettyPhone(value),
    },
    {
      Header: 'Type',
      accessor: 'type',
    },
    {
      Header: 'Created At',
      accessor: 'created_at',
    },
    {
      Header: 'Update At',
      accessor: 'updated_at',
    },
    ...(canEdit
      ? [
          {
            Header: 'Edit',
            disableSortBy: true,
            Cell: ({
              row: {
                original: { id, toggleEditPhoneModal },
              },
            }) => (
              <ButtonCellColumn
                onClick={() => toggleEditPhoneModal(id)}
                leftIcon={FaEdit}
              />
            ),
          },
          {
            Header: 'Delete',
            accessor: 'handleDeleteDetailsHandler',
            disableSortBy: true,
            Cell: ({
              row: {
                original: { id },
              },
            }) => (
              <ButtonCellColumn
                onClick={() =>
                  handleDeleteDetailsHandler({ id, type: 'phone' })
                }
                leftIcon={FaRegTrashAlt}
              />
            ),
          },
        ]
      : []),
  ];
  const toggleNewModal = () => {
    setModalType({ info_type: 'phone' });
    toggleModal();
  };

  const toggleEditPhoneModal = (id: any) => {
    const phone = phones.find((e) => e.id === id);
    setModalType({ ...phone, info_type: 'phone' });
    toggleEditModal();
  };
  return (
    <Card mt={20} mb={20}>
      {canEdit ? (
        <TableCardHeader
          name="Phone Numbers"
          action="Add Phone Number"
          onClick={toggleNewModal}
        />
      ) : (
        <TableCardHeader name="Phone Numbers" disabled />
      )}
      <Table
        name="phones"
        columns={CONTACT_PHONE_COLUMNS}
        data={phones.map((item) => ({
          ...item,
          toggleEditPhoneModal,
          handleDeleteDetailsHandler,
        }))}
      />
    </Card>
  );
};

export default ContactPhone;
